import React, { useState, useContext, useMemo, useEffect } from "react";
import { useNavigate } from "react-router";
import { AuthContext } from "../context/auth-context";
import { useDispatch, useSelector } from "react-redux";
import { fetchLLMOptions } from "../redux/actions/llmOptionsActions";
import { Divider, Popover, Typography } from "@mui/material";
// Users with feature_flags.is_assessment_ui_enabled get the grouped/accordion nav (V2); everyone else the original flat nav.
import SidebarOriginal from "../Component/Sidebar/Sidebar";
import SidebarV2 from "../Component/Sidebar/SidebarV2";
import { isAssessmentUiOn } from "../utils/navFlags";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import LogoutIcon from "@mui/icons-material/Logout";
import CheckIcon from "@mui/icons-material/Check";
import BusinessIcon from "@mui/icons-material/Business";
import { ENTITY_LABELS } from "../utils/labelMapping";
import { DiscoveryContext as DiscoveryContextV2 } from "./DiscoveryV2/discovery-context";
import { DiscoveryContext as BrandAuditDiscoveryContext } from "./BrandAudit/discovery-context";
import { CategoryAnalysisContext } from "./CategoryAnalysis/category-analysis-context";
const Layout = ({ children }) => {
  const { clearSession, selectedCustomerId, setSelectedCustomer } = useContext(AuthContext);
  const discoveryCtxV2 = useContext(DiscoveryContextV2);
  const brandAuditCtx = useContext(BrandAuditDiscoveryContext);
  const caCtx = useContext(CategoryAnalysisContext);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const authCtx = useContext(AuthContext);
  const [isDropdownOpen, setDropdownOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [industryOpen, setIndustryOpen] = useState(false);

  const groupCustomers = useSelector((state) => state.llmOptions.groupCustomers);

  const sortedGroupCustomers = useMemo(() => {
    if (!groupCustomers || groupCustomers.length < 2) return [];
    return groupCustomers;
  }, [groupCustomers]);

  const showIndustryPicker = sortedGroupCustomers.length >= 2;

  useEffect(() => {
    const userId = authCtx?.user?.user_role?.user_id;
    if (userId && groupCustomers.length === 0) {
      dispatch(fetchLLMOptions(userId));
    }
  }, [authCtx?.user?.user_role?.user_id]);
  const handleClickpop = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setIndustryOpen(false);
  };

  const handleIndustryChange = (entry) => {
    if (entry.id !== selectedCustomerId) {
      if (discoveryCtxV2.is_launched) {
        discoveryCtxV2.resetState();
        discoveryCtxV2.resetFormState(true);
      }
      if (brandAuditCtx.is_launched) {
        brandAuditCtx.resetState();
        brandAuditCtx.resetFormState(true);
      }
      if (caCtx.is_launched) {
        caCtx.resetState();
        caCtx.resetFormState(true);
      }
    }
    setSelectedCustomer(entry);
    handleClose();
  };

  const handleLogOut = () => {
    window.location.reload(true);
    clearSession();
    dispatch({ type: "LOGOUT" });
    navigate("/login");
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  return (
    <main>
      <div className="sidepanel d-flex flex-column flex-shrink-0 bg-light">
        <div style={{ borderBottom: "0.5px solid #B7C3CD", minHeight: "70px", backgroundColor: "white" }}>
          <a
            href="#"
            className="p-3 d-flex align-items-center link-dark text-decoration-none"
            style={{ cursor: "pointer", marginLeft: "18px", height: "70px", backgroundColor: "white" }}
          >
            <img
              src={"/Logo 0124.png"}
              width={130}
              height={130}
              style={{ objectFit: "contain", marginLeft: "-6px" }}
              alt="Brand-Luminaire"
            />
          </a>
          {ENTITY_LABELS.brandTitle && (
            <p style={{
              marginTop: "-16px",
              marginLeft: "66px",
              marginBottom: "6px",
              fontSize: "11px",
              fontWeight: 500,
              color: "#718096",
              letterSpacing: "0.03em",
              lineHeight: 1,
            }}>
              {ENTITY_LABELS.brandTitle}
            </p>
          )}
        </div>
        {isAssessmentUiOn(authCtx?.user) ? <SidebarV2 /> : <SidebarOriginal />}
      </div>
      <div className="main-content">
        <header>
          <div className="d-flex align-items-center justify-content-end mt-2">
            {/* <span className="me-4">
              <i className="feather icon-headphones"></i>
            </span>
            <span className="me-4">
              <i className="feather icon-bell"></i>
            </span> */}
            <div className="me-4">
              <div
                aria-describedby={id}
                onClick={handleClickpop}
                style={{ color: "#000", cursor: "pointer" }}
              >
                <i
                  alt=""
                  className="feather icon-user"
                  onClick={() => setDropdownOpen(!isDropdownOpen)}
                  id="profileImage"
                  style={{ cursor: "pointer" }}
                />
                <ArrowDropDownIcon />
              </div>
              <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "left",
                }}
              >
                <div style={{ padding: "10px", minWidth: 200 }}>
                  <Typography sx={{ color: "#555" }} variant="string">
                    Hello,{" "}
                    <span style={{ color: "#007bff", fontWeight: "bold" }}>
                      {authCtx?.user?.email}
                    </span>
                  </Typography>
                  <Divider className="mt-2" sx={{ bgcolor: "secondary.light" }} />

                  {showIndustryPicker && (
                    <>
                      <div
                        onClick={() => setIndustryOpen((prev) => !prev)}
                        style={{
                          cursor: "pointer",
                          display: "flex",
                          alignItems: "center",
                          padding: "7px 8px",
                          borderRadius: 6,
                          marginTop: 4,
                          gap: 8,
                          backgroundColor: industryOpen ? "#eef3ff" : "transparent",
                        }}
                      >
                        <BusinessIcon sx={{ fontSize: 14, color: "#007bff", flexShrink: 0 }} />
                        <Typography variant="body2" sx={{ color: "#444", fontWeight: 500, flex: 1 }}>
                          Industry
                        </Typography>
                        <div
                          style={{
                            backgroundColor: "#eef3ff",
                            border: "1px solid #cfe0ff",
                            borderRadius: 12,
                            padding: "2px 8px",
                            maxWidth: 90,
                            overflow: "hidden",
                          }}
                        >
                          <Typography
                            variant="caption"
                            sx={{
                              color: "#007bff",
                              fontWeight: 600,
                              display: "block",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {sortedGroupCustomers.find((c) => c.id === selectedCustomerId)?.industry || ""}
                          </Typography>
                        </div>
                        <ArrowDropDownIcon
                          sx={{
                            fontSize: 18,
                            color: "#888",
                            flexShrink: 0,
                            transform: industryOpen ? "rotate(180deg)" : "rotate(0deg)",
                            transition: "transform 0.2s ease",
                          }}
                        />
                      </div>
                      {industryOpen && (
                        <div
                          style={{
                            marginTop: 2,
                            marginBottom: 4,
                            marginLeft: 6,
                            borderLeft: "2px solid #cfe0ff",
                            paddingLeft: 8,
                          }}
                        >
                          {sortedGroupCustomers.map((entry) => (
                            <div
                              key={entry.id}
                              onClick={() => handleIndustryChange(entry)}
                              style={{
                                cursor: "pointer",
                                padding: "6px 8px",
                                borderRadius: 4,
                                display: "flex",
                                alignItems: "center",
                                gap: 6,
                                backgroundColor: entry.id === selectedCustomerId ? "#eef3ff" : "transparent",
                              }}
                            >
                              <CheckIcon
                                sx={{
                                  fontSize: 13,
                                  visibility: entry.id === selectedCustomerId ? "visible" : "hidden",
                                  color: "#007bff",
                                  flexShrink: 0,
                                }}
                              />
                              <Typography
                                variant="body2"
                                sx={{
                                  fontWeight: entry.id === selectedCustomerId ? 600 : 400,
                                  color: entry.id === selectedCustomerId ? "#007bff" : "#444",
                                  fontSize: "0.82rem",
                                }}
                              >
                                {entry.industry}
                              </Typography>
                            </div>
                          ))}
                        </div>
                      )}
                      <Divider sx={{ mt: 1, bgcolor: "secondary.light" }} />
                    </>
                  )}

                  <div className="py-2 d-flex flex-row justify-content-start align-items-center">
                    <LogoutIcon fontSize="small" sx={{ color: "#555", marginRight: 1 }} />
                    <Typography style={{ cursor: "pointer" }} onClick={handleLogOut}>
                      Sign Out
                    </Typography>
                  </div>
                </div>
              </Popover>
            </div>
          </div>
        </header>
        {children}
      </div>
    </main>
  );
};

export default Layout;
